import React from 'react';
import ReactDOM from 'react-dom';
import Router from './Router';
import './tailwind.output.css';
import './App.scss'

ReactDOM.render(<Router />,
  document.getElementById('root')
);
//https://codepen.io/stezu/pen/cmLrI